import { axios as myaxios, getNumericalHeader, getClientUrl } from "../utils";

const getUserRole = async (forceRefresh = false) => {
  const username = localStorage.getItem("username");
  const cachedDataString = localStorage.getItem("user_role_data");

  if (cachedDataString && !forceRefresh) {
    try {
      const cachedData = JSON.parse(cachedDataString);
      // Verify it matches current user
      if (cachedData && cachedData.data && cachedData.data.username === username) {
        return cachedData;
      }
    } catch (e) {
      console.error("Error parsing cached user role:", e);
      localStorage.removeItem("user_role_data");
    }
  }

  try {
    const response = await myaxios.get(getClientUrl("v1/user-role/"), {
      ...getNumericalHeader(),
      params: {
        username: username,
      },
    });

    if (response.data) {
      localStorage.setItem("user_role_data", JSON.stringify(response.data));
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching user role:", error);
    return null; // Or handle error appropriately
  }
};

export {
  getUserRole
}
